export const maxRetries = 3;
